<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Reportes de boletas pendientes de generar
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition(name="fade")
      .contenedor-frame(
        v-if="activateFrame"
        v-on-clickaway="cerrarFrame"
      )
        .titulo
          span.texto {{ tituloFrame }}
          .button(@click="cerrarFrame")
            span Cerrar
        iframe(
          :src="path"
        )
          | Oops! an error has occurred.

    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)

          .filtros(v-if="mostrarFiltros", key="filtros")

            .filtro
              .title-singular
                p Año
              .select.display-flex
                select.flex-1(v-model='filtroPeriodo')
                  option(:value="o", v-for="o in periodos") {{o}}

            .filtro
              .title-singular
                p Mes
              .select.display-flex
                select.flex-1(v-model='filtroMes')
                  option(:value="o.codigo", v-for="o in meses") {{o.descripcion}}

            .filtro
              .title-singular
                p Tipo
              .select.display-flex
                select.flex-1(v-model='filtroTipo')
                  option(:value="o.codigo", v-for="o in tipos") {{o.descripcion}}
          .boton-container(key="boton-container")
            button.button(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar
      .body(key="body")
        .is-loading(v-if="isLoading")
          .icon
            i.fa.fa-spinner.fa-spin
        .information(v-else)
          template(v-if="lista.length !== 0")
            .is-desktop
              table.table.is-striped.is-bordered
                thead
                  th Empleado
                  th Fecha de Ingreso
                  th DNI
                  th Jefe
                tbody(
                  name="table-row"
                  is="transition-group"
                )
                  tr.row-table(
                    v-for="(o, index) in lista"
                    :key="index"
                  )
                    td
                      span {{ o.nombre }}
                      span.email  ({{ o.cargo }})
                      br
                      span.email {{ o.email }}
                    td {{ o.fechaIngresoString }}
                    td {{ o.dni }}
                    td
                      span.name.hint--top(:aria-label="'Jefe: ' + o.dniJefe")  {{ o.nombreJefe }}
                      br
                      span.email {{ o.emailJefe }}
            .is-mobile
              .box.has-text-left(
                v-for="(o, index) in lista"
                :key="index+'-mobile'"
              )
                div.mt-10
                  span.name {{ o.nombre }}
                div
                  span.text-small DNI:&nbsp;
                  span {{ o.dni }}
                div
                  span.text-small Cargo:&nbsp;
                  span {{ o.cargo }}
                div
                  span.text-small Email:&nbsp;
                  span {{ o.email }}
                div
                  span.text-small Fecha de Ingreso:&nbsp;
                  span {{ o.fechaIngresoString }}
                template(v-if="codigoLogueadoJefe !== (o.codigoJefe + '')")
                  div
                    div.hint--top(:aria-label="'Jefe: ' + o.dniJefe")
                      span.text-small Jefe:&nbsp;
                      span {{ o.nombreJefe }}
                    div
                      span.text-small Email:&nbsp;
                      span {{ o.emailJefe }}
          div(v-else)
            .message.is-warning
              .message-body No hay boletas que cumplan con los siguientes filtros
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import { apiGet, apiPost, notify } from '../util/general'
export default {
  name: 'lista_boletas_pendientes_generar',
  data () {
    return {
      lista                 : [],
      codigoLogueadoJefe:localStorage.getItem('codigo') + '',
      isLoading                   : false,
      mostrarBusquedaEmpleado     : false,
      mostrarFiltros              : true,
      solicitudSeleccionada       : {},
      filtroCodigoEmpleado        : '',
      filtroTipo                  : '',
      filtroMes                   : 'all',
      filtroPeriodo               : '',
      filtroVisto                 : '',
      tipos                       : [],
      meses                       : [
        { codigo: 1, descripcion: 'Enero' },
        { codigo: 2, descripcion: 'Febrero' },
        { codigo: 3, descripcion: 'Marzo' },
        { codigo: 4, descripcion: 'Abril' },
        { codigo: 5, descripcion: 'Mayo' },
        { codigo: 6, descripcion: 'Junio' },
        { codigo: 7, descripcion: 'Julio' },
        { codigo: 8, descripcion: 'Agosto' },
        { codigo: 9, descripcion: 'Setiembre' },
        { codigo: 10, descripcion: 'Octubre' },
        { codigo: 11, descripcion: 'Noviembre' },
        { codigo: 12, descripcion: 'Diciembre' }
      ],
      periodos      : [],
      path          : '',
      activateFrame : false
    }
  },
  components: {
    LookupSmallEmpleado
  },
  created () {
    this.limpiarFiltros()
    this.loadPeriodos()
    this.fetchTipos()
    this.fetch()
  },
  watch : {
    filtroCodigoEmpleado (value) {
      return this.fetch()
    },
    filtroTipo (value) {
      return this.fetch()
    },
    filtroMes (value) {
      return this.fetch()
    },
    filtroPeriodo (value) {
      return this.fetch()
    },
    filtroVisto (value) {
      return this.fetch()
    }
  },
  methods: {
    loadPeriodos () {
      var vm = this
      var periodoInicial = 2018
      var periodoActual = +window.moment().format('YYYY')
      vm.filterPeriodo = periodoActual

      while (periodoActual >= periodoInicial) {
        vm.periodos.push(periodoActual)
        periodoActual--
      }
    },
    fetchTipos () {
      var vm = this
      var obj = {
      }
      apiGet(vm, '/boleta/tipos', obj, function (data) {
        vm.tipos = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true

      var filtros = {
        periodo        : vm.filtroPeriodo,
        mes            : vm.filtroMes,
        tipo           : vm.filtroTipo,
        codigoEmpleado : vm.filtroCodigoEmpleado,
        visto          : vm.filtroVisto
      }

      var obj = {
        filtros: filtros
      }
      apiGet(vm, '/boleta/pendiente-generar', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtroCodigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtroTipo           = 1
      this.filtroCodigoEmpleado = ''
      this.filtroMes            = +window.moment().format('MM')
      this.filtroPeriodo        = +window.moment().format('YYYY')
      this.filtroVisto          = 'all'
    },
    verPdf (boleta) {
      var vm = this
      // Obtener path enviando los datos
      vm.tituloFrame = 'Boleta de ' + boleta.nombreMes + ' ' + boleta.periodo + ' - ' + boleta.descripcionTipo
      vm.activateFrame = true
      var token = localStorage.getItem('token')
      this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&codigo=' + boleta.codigo + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      // this.path = process.env.API_ROUTE + '/boleta/empleado/pdf?token=' + token + '&empresa=' + process.env.EMPRESA + '&periodo=' + boleta.periodo + '&mes=' + boleta.mes + '&tipo=' + boleta.tipo
      // Scroll top
      // document.body.scrollTop = 0; // For Safari
      // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    cerrarFrame () {
      this.path = ''
      this.activateFrame = false
    },
    notificar (o) {
      var vm = this

      var obj = {
        periodo : o.periodo,
        mes     : o.mes,
        tipo    : o.tipo,
        codigo  : o.codigo
      }

      apiPost(vm, '/boleta/empleado/notificar', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Se le notifico al empleado')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      padding-right: 5px;
      padding-left: 5px;
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px



  .is-loading
    margin-top 10px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;

  .text-align-center
    text-align center

  .contenedor-frame
    position fixed
    background-color #ccc
    left 1
    top: 0px;
    left: 0px;
    width: 100%;
    height 100vh;
    padding 20px
    transition all 0.5s ease
    z-index: 9999

    .titulo
      display flex
      align-items center
      .texto
        flex 1
        text-align left
        font-size 25px
      .button
        margin-bottom 10px

    iframe
      width 100%
      height calc(100% - 30px);
  td
    .email
      font-size 12px
      color #9a9a9a

  .is-mobile
    display none
  .text-small
    font-size 12px
    color #9a9a9a
  @media (max-width 640px)
    .is-mobile
      display block
    .is-desktop
      display none
    .name
      font-size: 16px;


  @media (max-width: 535px)
    .filtros
      flex-direction column
      .filtro
        width 100%
</style>



// WEBPACK FOOTER //
// Component_Boletas_Pendientes_Lista.vue?5163c06c